/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { v4 as uuidv4 } from 'uuid';
import {
  Segment, Dimmer, Loader, Label, Icon, Pagination, Input, Modal
} from 'semantic-ui-react';
import cx from 'classnames';
import Update from 'immutability-helper';
import { Scrollbars } from 'react-custom-scrollbars-2';
import $ from 'jquery';
import { withTranslation } from 'react-i18next';
import WithRouter from '../Extensions/WithRouter';
import Footer from '../Footer/Footer';
import api from '../../api';
import ContentsHeaderWithResultAll from '../SubHeader/ContentsHeaderWithResultAll';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import expandBtn from '../../images/components/content_file/expand-btn.svg';
import closeBtn from '../../images/components/content_wide_card/closeBtn.png';
import LitigatorRow from './LitigatorRow';

class LitigatorList extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.smallBody = null;
    this.viewRef = React.createRef();
    this.litigatorBody = React.createRef();
    this.state = {
      pageSize: this.props.state.user.page_limit,
      currentPage: 1,
      totalPage: '',
      viewMode: this.props.state.user.view_mode,
      litigatorList: [],
      error: null,
      isLoading: false,
      isDetailLoading: false,
      isVisible: '',
      hasMore: false,
      activeIndex: [],
      sortValue: '7',
      isSort: false,
      filter: [],
      searchKeyword: '',
      startDate: '',
      endDate: '',
      radioValue: 'dttime_any',
      popupIndex: [],
      popupType: '',
      activePage: '',
      pdfElement: '',
      isRenderListOnly: false,
      isOpenWarnModal: false,
      totalCount: 0,
    };
    this.handleOnScroll = this.handleOnScroll.bind(this);
    this.toggleRow = this.toggleRow.bind(this);
    this.onChangeSorting = this.onChangeSorting.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.clearRadioValue = this.clearRadioValue.bind(this);
    this.clearAllValue = this.clearAllValue.bind(this);
    this.handleFilterData = this.handleFilterData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleMoreInfo = this.handleMoreInfo.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.toggleViewMode = this.toggleViewMode.bind(this);
    this.handleInputActivePageChange = this.handleInputActivePageChange.bind(this);
    this.handleActivePageChange = this.handleActivePageChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.createElementWithCanvas = this.createElementWithCanvas.bind(this);
    this.generatePdfCallback = this.generatePdfCallback.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.props.state.user.initPrecisionLevel();
    window.addEventListener('scroll', this.handleOnScroll);
    const $contentsHeader = $('.contents_header');
    const $tableHeader = $('.table_header');
    const $window = $(window);

    $window.on('scroll.contents_header', () => {
      if ($window.scrollTop() > 140) {
        $contentsHeader.addClass('fixed');
        $tableHeader.addClass('fixed');
      } else {
        $contentsHeader.removeClass('fixed');
        $tableHeader.removeClass('fixed');
      }
    });
    document.addEventListener('mousedown', this.handleClickOutside);
    if (this.litigatorBody) {
      this.getLitigatorList();
    }
    this.renderPopup();
    window.scrollTo(0, 0);
  }

  componentDidUpdate() {
    const { state } = this.props;
    const { viewMode, pageSize } = this.state;

    const userStore = { ...state.user };

    if (viewMode === '' && userStore.view_mode !== '') {
      this.setState({
        viewMode: userStore.view_mode,
      });
    }

    if (pageSize === '' && userStore.page_limit !== '') {
      this.setState({
        pageSize: userStore.page_limit,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    const { popupIndex, popupType } = this.state;
    const container = $('.card_detail_popup');
    if (container && container.has(event.target).length === 0) {
      if (popupIndex.length !== 0 && popupType !== '') {
        this.setState({
          popupIndex: '',
          popupType: '',
        });
      }
    }
  }

  handleOnScroll() {
    const {
      getLitigatorList,
      state: {
        error, isLoading, hasMore, viewMode
      },
    } = this;

    if (viewMode === 'list') {
      return;
    }

    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;
    if (error || isLoading || !hasMore) {
      return;
    }
    if (scrollTop + clientHeight >= scrollHeight) {
      getLitigatorList(this.state.currentPage + 1);
    }
  }

  handleChange(value) {
    this.setState(
      {
        searchKeyword: value,
        litigatorList: [],
        activeIndex: [],
      },
      () => {
        this.getLitigatorList();
      }
    );
  }

  handleFilterData(value) {
    this.setState(
      {
        litigatorList: [],
        activeIndex: [],
        startDate: value.uploaded_start,
        endDate: value.uploaded_end,
        radioValue: value.radio,
      },
      () => {
        this.getLitigatorList();
      }
    );
  }

  handlePageSizeChange(value) {
    this.setState(
      {
        pageSize: value,
        currentPage: 1,
        litigatorList: [],
        activeIndex: [],
      },
      () => {
        this.getLitigatorList();
      }
    );
  }

  handleActivePageChange(e) {
    const { totalPage, pageSize, activePage } = this.state;
    if (e.key === 'Enter') {
      if (activePage > totalPage) {
        return;
      }
      this.setState({
        litigatorList: [],
        activeIndex: [],
        currentPage: activePage,
      }, () => {
        this.getLitigatorList(activePage, pageSize);
      });
    }
  }

  handleSearchChange(value) {
    this.setState({
      searchKeyword: value,
    });
  }

  handleInputActivePageChange(e, { value }) {
    const { totalPage } = this.state;
    if (totalPage < value) {
      return;
    }

    this.setState({
      activePage: value,
    });
  }

  onChangeSorting = (e) => {
    const { isSort } = this.state;
    if (e.currentTarget.dataset.id !== this.state.sortValue) {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: false,
          litigatorList: [],
          activeIndex: [],
        },
        () => {
          this.getLitigatorList();
        }
      );
    } else {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: !isSort,
          litigatorList: [],
          activeIndex: [],
        },
        () => {
          this.getLitigatorList();
        }
      );
    }
  };

  getLitigatorList = (pageNo, limit) => {
    let text;
    let filterData;
    const {
      isSort, sortValue, radioValue, litigatorList, pageSize, filter
    } = this.state;
    const { state, t } = this.props;
    const userStore = { ...state.user };
    const page = pageNo || 1;
    let perPage = limit || pageSize;
    if (perPage === '') {
      perPage = userStore.page_limit || localStorage.getItem('page_limit');
    }

    if (filter.length !== 0) {
      let i = 0;
      for (i; i < filter.length; i++) {
        if (i === 0) {
          filterData = filter[i];
        } else {
          filterData = `${filterData},${filter[i]}`;
        }
      }
      filterData = `${filterData},${radioValue}`;
    } else {
      filterData = `${radioValue}`;
    }
    switch (true) {
    case sortValue === '1':
      if (isSort) {
        text = 'litigator_name';
      } else {
        text = 'litigator_name_r';
      }
      break;
    case sortValue === '2':
      if (isSort) {
        text = 'component_count_r';
      } else {
        text = 'component_count';
      }
      break;
    case sortValue === '3':
      if (isSort) {
        text = 'component_version_count_r';
      } else {
        text = 'component_version_count';
      }
      break;
    case sortValue === '4':
      if (isSort) {
        text = 'project_count_r';
      } else {
        text = 'project_count';
      }
      break;
    case sortValue === '5':
      if (isSort) {
        text = 'project_version_count_r';
      } else {
        text = 'project_version_count';
      }
      break;
    case sortValue === '6':
      if (isSort) {
        text = 'uploaded_file_count_r';
      } else {
        text = 'uploaded_file_count';
      }
      break;
    case sortValue === '7':
      if (isSort) {
        text = 'last_detected_r';
      } else {
        text = 'last_detected';
      }
      break;
    default:
      text = 'last_detected';
      break;
    }
    this.setState(
      {
        isLoading: true,
      },
      () => {
        api
          .getLitigatorList(
            {
              search: this.state.searchKeyword,
              filter: filterData,
              detected_start: this.state.startDate,
              detected_end: this.state.endDate,
              page,
              limit: perPage,
              order: text,
            }
          )
          .then((response) => {
            if (this.state.litigatorList.length !== 0 && response.pagination.current === 1) {
              return false;
            }
            const nextLitigatorList = response.response.map((item) => {
              return {
                litigatorName: item.litigator_name,
                componentCount: item.component_count,
                componentVersionCount: item.component_version_count,
                projectCount: item.project_count,
                projectVersionCount: item.project_version_count,
                uploadedFileCount: item.uploaded_file_count,
                lastDetected: item.last_detected,
                litigatorCode: item.litigator_code,
              };
            });

            this.setState({
              currentPage: response.pagination.current,
              pageSize: response.pagination.per_page,
              totalPage: response.pagination.pages,
              totalCount: response.pagination.count,
              hasMore: response.pagination.next !== null,
              isLoading: false,
              litigatorList: [...litigatorList, ...nextLitigatorList],
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              error: t('modal.error.error_load'),
              isLoading: false,
            });
          });
      }
    );
  };

  getLitigatorDetail = (litigatorCode) => {
    const { t } = this.props;
    const objData = {
      litigator_name: litigatorCode,
    };

    this.setState({
      isDetailLoading: true,
      isVisible: litigatorCode,
    }, () => {
      api
        .getLitigatorDetail(objData)
        .then((response) => {
          const { litigatorList } = this.state;
          const data = response.response;
          const updatedIndex = litigatorList.findIndex((item) => {
            return item.litigatorCode === litigatorCode;
          });
          const updatedData = Update(litigatorList[updatedIndex], {
            litigatorDetail: { $set: data },
          });
          const newData = Update(litigatorList, {
            $splice: [[updatedIndex, 1, updatedData]],
          });
          this.setState({
            litigatorList: newData,
            isDetailLoading: false,
            isVisible: '',
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            error: t('modal.error.error_load'),
            isDetailLoading: false,
            isVisible: '',
          });
        });
    });
  };

  createElementWithCanvas = () => {
    const { t } = this.props;
    //pdfElement
    const contentElem = document.querySelector('.content');
    if (contentElem) {
      const wrapper = contentElem.closest('.container');
      const clonedObject = wrapper.cloneNode(true);
      const containerEl = clonedObject.closest('.container');
      containerEl.style.paddingTop = 0;

      if (clonedObject) {
        const resultHeaderEl = clonedObject.getElementsByClassName('result_header');
        const resultHeaderInnerEl = clonedObject.getElementsByClassName('result_header_inner');
        const contentsSummaryInnerEl = clonedObject.getElementsByClassName('contents_summary_inner');
        const contentsEl = clonedObject.getElementsByClassName('contents');
        const utilWrapEl = clonedObject.getElementsByClassName('util_wrap');
        const moveTopEl = clonedObject.getElementsByClassName('move_to_top');
        const pageEle = clonedObject.getElementsByClassName('clar_pagination');
        const footerEl = clonedObject.getElementsByClassName('footer');
        const tableEl = clonedObject.getElementsByClassName('wide_card_box');
        const expandTableEl = clonedObject.getElementsByClassName('wide_card_box expand');

        if (expandTableEl.length !== 0) {
          this.modalBody = t('modal.error.clraity_report_main_warn');
          this.smallBody = t('modal.error.clarity_reporty_sub_warn');
          return this.setState({
            isOpenWarnModal: true,
          });
        }

        if (resultHeaderEl.length !== 0) {
          resultHeaderEl[0].style.top = 0;
        }

        if (resultHeaderInnerEl.length !== 0) {
          resultHeaderInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsSummaryInnerEl.length !== 0) {
          contentsSummaryInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsEl.length !== 0) {
          contentsEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (utilWrapEl.length !== 0) {
          while (utilWrapEl.length > 0) {
            utilWrapEl[0].parentNode.removeChild(utilWrapEl[0]);
          }
        }

        if (moveTopEl.length !== 0) {
          while (moveTopEl.length > 0) {
            moveTopEl[0].parentNode.removeChild(moveTopEl[0]);
          }
        }

        if (pageEle.length !== 0) {
          while (pageEle.length > 0) {
            pageEle[0].parentNode.removeChild(pageEle[0]);
          }
        }

        if (footerEl.length !== 0) {
          while (footerEl.length > 0) {
            footerEl[0].parentNode.removeChild(footerEl[0]);
          }
        }

        //wide_card_box wide_card_type_01
        if (tableEl.length > 16) {
          let i = 0;
          for (i; i < tableEl.length; i++) {
            if ((i === 15 && tableEl.length > 16) || (i > 15 && (i - 15) % 18 === 0)) {
              tableEl[i].classList.add('page-break');
            }
          }
        }
      }

      document.body.appendChild(clonedObject);

      this.setState({
        pdfElement: clonedObject,
        isRenderListOnly: true,
      });
    }
  };

  generatePdfCallback = () => {
    const { pdfElement } = this.state;

    document.body.removeChild(pdfElement);
    this.setState({
      pdfElement: '',
      isRenderListOnly: false,
    });
  };

  toggleRow = (index, litigatorName) => {
    const { activeIndex } = this.state;
    let newState;

    if (activeIndex.indexOf(index) > -1) {
      newState = activeIndex.filter((i) => {
        return i !== index;
      });
    } else {
      this.getLitigatorDetail(litigatorName);
      newState = [...activeIndex, index];
    }
    this.setState({
      activeIndex: newState,
    });
  };

  toggleViewMode = (value) => {
    this.setState({
      viewMode: value,
      currentPage: 1,
      searchKeyword: '',
      litigatorList: [],
      activeIndex: [],
    }, () => {
      this.getLitigatorList();
    });
  };

  handlePaginationChange = (e, { activePage }) => {
    const { pageSize } = this.state;
    this.setState({
      litigatorList: [],
      activeIndex: [],
      currentPage: activePage,
      activePage,
    }, () => {
      this.getLitigatorList(activePage, pageSize);
    });
  };

  clearRadioValue = () => {
    this.setState(
      {
        litigatorList: [],
        activeIndex: [],
        startDate: '',
        endDate: '',
        radioValue: 'dttime_any',
      },
      () => {
        this.getLitigatorList();
      }
    );
  };

  clearAllValue = () => {
    this.setState(
      {
        litigatorList: [],
        activeIndex: [],
        startDate: '',
        endDate: '',
        radioValue: 'dttime_any',
      },
      () => {
        this.getLitigatorList();
      }
    );
  };

  handleMoreInfo = (index) => {
    const { popupIndex } = this.state;
    let newState;

    if (popupIndex.indexOf(index) === -1) {
      newState = [...popupIndex, index];
    } else {
      newState = popupIndex;
    }

    this.setState({
      popupIndex: newState,
      popupType: 'type_0',
    });
  };

  handlePopupClose = (index) => {
    const { popupIndex } = this.state;
    const newState = popupIndex.filter((i) => {
      return i !== index;
    });

    this.setState({
      popupIndex: newState,
      popupType: '',
    });
  };

  closeModal = () => {
    this.modalBody = null;
    this.smallBody = null;
    this.setState({
      isOpenWarnModal: false,
    });
  };

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        litigatorList: [],
        activeIndex: [],
      },
      () => {
        this.getLitigatorList();
      }
    );
  }

  renderValue() {
    const { t } = this.props;
    const { radioValue } = this.state;
    const uploadedDateFilter = radioValue;

    const filterObj = { datetime: uploadedDateFilter, };

    return (
      <div>
        {filterObj.datetime.indexOf('dttime_any') === -1 && (
          <Label.Group>
            <span>
              <strong>{t('project.menu.date')}</strong>
            </span>
            <Label as="a">
              {filterObj.datetime.indexOf('dttime_p24') > -1 && t('contents_header.menu.past_24_hours')}
              {filterObj.datetime.indexOf('dttime_pw') > -1 && t('contents_header.menu.past_week')}
              {filterObj.datetime.indexOf('dttime_pm') > -1 && t('contents_header.menu.past_month')}
              {filterObj.datetime.indexOf('dttime_cr') > -1
                  && `${this.state.startDate}~${this.state.endDate}`}
              <Icon
                name="close"
                onClick={() => {
                  return this.clearRadioValue();
                }}
              />
            </Label>
          </Label.Group>
        )}
        {radioValue.indexOf('dttime_any') === -1 ? (
          <div
            className="clear_all"
            onClick={() => {
              return this.clearAllValue();
            }}
            onKeyUp={() => {
              return this.clearAllValue();
            }}
          >
            {t('project.menu.clear_all_filters')}
          </div>
        ) : null}
      </div>
    );
  }

  renderPopup() {
    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tac', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tal', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  render() {
    const {
      error,
      hasMore,
      isLoading,
      isDetailLoading,
      isVisible,
      litigatorList,
      activeIndex,
      isSort,
      sortValue,
      radioValue,
      popupIndex,
      popupType,
      viewMode,
      pageSize,
      currentPage,
      totalPage,
      activePage,
      pdfElement,
      startDate,
      endDate,
      searchKeyword,
      totalCount
    } = this.state;

    const {
      state, location, params, t, navigate
    } = this.props;

    return (
      <div ref={this.litigatorBody}>
        <ContentsHeaderWithResultAll
          onChangeSearch={this.handleChange}
          onSubmit={this.handleFilterData}
          clearSearch={this.clearSearch}
          radioValue={radioValue}
          viewMode={viewMode}
          pageSize={pageSize}
          handlePageSizeChange={this.handlePageSizeChange}
          toggleViewMode={this.toggleViewMode}
          refElement={pdfElement}
          currentPage={currentPage}
          isRenderListOnly={this.state.isRenderListOnly}
          createElementWithCanvas={this.createElementWithCanvas}
          generatePdfCallback={this.generatePdfCallback}
          state={state}
          location={location}
          params={params}
          translate={t}
          startDate={startDate}
          endDate={endDate}
          navigate={navigate}
          searchKeyword={searchKeyword}
          handleSearchChange={this.handleSearchChange}
          totalCount={totalCount}
        />
        <div className="content">
          {radioValue.indexOf('dttime_any') === -1 ? (
            <div className="tag_list">{this.renderValue()}</div>
          ) : (
            ''
          )}
          <div className="content_projects_List">
            <div className="wide_card_wrap">
              <div className="table_header">
                <div className="table_header_inner">
                  <table className="wide_card_table wide_card_scope">
                    <colgroup>
                      <col style={{ width: '3.9%', maxWidth: '36px' }} />
                      <col style={{ width: '22.1%', maxWidth: '204px' }} />
                      <col style={{ width: '9%' }} />
                      <col style={{ width: '9%' }} />
                      <col style={{ width: '38.7%' }} />
                      <col style={{ width: '13%' }} />
                      <col style={{ width: '4.3%', maxWidth: '40px' }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th className="checkbox_wrap tal">
                          <div className="checkbox" />
                        </th>
                        <th className="tal">
                          <a className="sorting_button" data-id="1" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.litigator_code')}
                            {isSort && sortValue === '1' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '1' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="2" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.component')}
                            {isSort && sortValue === '2' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '2' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="3" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.component_version_ellipsis')}
                            {isSort && sortValue === '3' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '3' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="sum_th">
                          <table>
                            <colgroup>
                              <col style={{ width: '33%' }} />
                              <col style={{ width: '33%' }} />
                              <col style={{ width: '33%' }} />
                            </colgroup>
                            <tbody>
                              <tr>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="4"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('list.title.project')}
                                    {isSort && sortValue === '4' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '4' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="5"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('list.title.project_version')}
                                    {isSort && sortValue === '5' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '5' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="6"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('list.title.uploaded_files')}
                                    {isSort && sortValue === '6' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '6' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="7" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            Last Detected
                            {isSort && sortValue === '7' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '7' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th>&nbsp;</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {litigatorList.map((item, index) => {
                return (
                  <div
                    className={cx(
                      'wide_card_box',
                      {
                        expand: activeIndex.indexOf(index) >= 0,
                      },
                      {
                        card_detail_popup_show: popupIndex.indexOf(index) >= 0,
                      },
                      {
                        type_0: popupType === 'type_0',
                      },
                    )}
                    key={uuidv4()}
                  >
                    <table className="wide_card_table wide_card_item">
                      <colgroup>
                        <col style={{ width: '3.9%', maxWidth: '36px' }} />
                        <col style={{ width: '22.1%', maxWidth: '204px' }} />
                        <col style={{ width: '57%' }} />
                        <col style={{ width: '4.3%', maxWidth: '40px' }} />
                      </colgroup>
                      <tbody>
                        <tr
                          className="sum_line"
                          onClick={() => {
                            return this.toggleRow(index, item.litigatorCode);
                          }}
                        >
                          <td className="checkbox_wrap border-none tal">
                            <div className="checkbox" />
                          </td>
                          <td className="border-none tal">
                            <strong>{item.litigatorName}</strong>
                          </td>
                          <td className="tal sum_td" colSpan="4">
                            <table className="wide_card_table wide_card_item">
                              <colgroup>
                                <col style={{ width: '12.9%' }} />
                                <col style={{ width: '12.9%' }} />
                                <col style={{ width: '55.5%' }} />
                                <col style={{ width: '18.6%' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <td className="tac">{item.componentCount}</td>
                                  <td className="tac">{item.componentVersionCount}</td>
                                  <td className="sum_td tac">
                                    <table className="sub_table">
                                      <colgroup>
                                        <col style={{ width: '33%' }} />
                                        <col style={{ width: '33%' }} />
                                        <col style={{ width: '33%' }} />
                                      </colgroup>
                                      <tbody>
                                        <tr>
                                          <td className="tac">{item.projectCount}</td>
                                          <td className="tac">{item.projectVersionCount}</td>
                                          <td className="tac">{item.uploadedFileCount}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                  <td className="tac">{item.lastDetected}</td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td className="border-none tac">
                            <a className="expand_button">
                              <img src={expandBtn} alt="" />
                            </a>
                          </td>
                        </tr>
                        {
                          isDetailLoading && isVisible === item.litigatorCode ? (
                            <tr>
                              <td className="border-none" colSpan="6">
                                <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
                                  <Loader active={isDetailLoading && isVisible === item.litigatorCode} inline="centered" />
                                </div>
                              </td>
                            </tr>
                          ) : (
                            <tr className="extend_item">
                              <td className="checkbox_wrap border-none tal">&nbsp;</td>
                              <td className="border-none tal">&nbsp;</td>
                              <td className="tal border-none sum_td" colSpan="4">
                                {
                                  item.litigatorDetail
                                  && (
                                    <LitigatorRow
                                      childRef={this.viewRef}
                                      rowData={item.litigatorDetail}
                                      t={t}
                                      state={state}
                                    />
                                  )
                                }
                              </td>
                            </tr>
                          )
                        }
                      </tbody>
                    </table>
                    {item.litigatorDetail ? (
                      <div className="wide_card_detail">
                        <div className="wide_card_detail_top type_description">
                          <p className="description">{t('list.title.description')}</p>
                          <p className="version_text">{item.litigatorDetail.description}</p>
                          {/**
                            <p className="foo">
                              Related Licenses
                            </p>
                            <p className="version_text">
                              {item.litigatorDetail.score}
                            </p>
                            */}
                        </div>
                        <div className="wide_card_detail_bottom">
                          <a
                            className={cx('card_detail_popup_show', {
                              active: popupIndex.indexOf(index) >= 0 && popupType === 'type_0',
                            })}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              return this.handleMoreInfo(index);
                            }}
                            onKeyUp={() => {
                              return this.handleMoreInfo(index);
                            }}
                          >
                            {t('list.title.more_information')}
                          </a>
                        </div>
                      </div>
                    ) : null}
                    {item.litigatorDetail ? (
                      <div className="card_detail_popup card_detail_popup_1">
                        <div className="popup_box">
                          <h3 className="popup_header">
                            {t('list.title.more_information')}
                            <a
                              className="card_detail_popup_hide"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                return this.handlePopupClose(index);
                              }}
                              onKeyUp={() => {
                                return this.handlePopupClose(index);
                              }}
                            >
                              <img src={closeBtn} alt="" />
                            </a>
                          </h3>
                          <div className="popup_content">
                            <Scrollbars
                              renderTrackHorizontal={() => {
                                return <div />;
                              }}
                              renderThumbHorizontal={() => {
                                return <div />;
                              }}
                            >
                              <div className="type_5">
                                {
                                  item.litigatorDetail.more_information ? (
                                    <dl>
                                      <dt>
                                        {
                                          item.litigatorDetail.more_information.more_description ? (
                                            item.litigatorDetail.more_information.more_description.title
                                          ) : null
                                        }
                                      </dt>
                                      <dd>
                                        {
                                          item.litigatorDetail.more_information.more_description ? (
                                            item.litigatorDetail.more_information.more_description.text
                                          ) : null
                                        }
                                      </dd>
                                    </dl>
                                  ) : (
                                    <dl>
                                      <dt>
                                        null
                                      </dt>
                                      <dd>
                                        null
                                      </dd>
                                    </dl>
                                  )
                                }
                              </div>
                              {
                                item.litigatorDetail.more_information ? (
                                  <div>
                                    {item.litigatorDetail.more_information.url
                                      && item.litigatorDetail.more_information.url.length !== 0 ? (
                                        <div>
                                          <div className="line" />
                                          {item.litigatorDetail.more_information.url.map((urlList) => {
                                            return (
                                              <dl key={uuidv4()}>
                                                <dt>{urlList.title}</dt>
                                                <dd>
                                                  <a
                                                    href={urlList.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                  >
                                                    {urlList.url}
                                                  </a>
                                                </dd>
                                              </dl>
                                            );
                                          })}
                                        </div>
                                      ) : null}
                                  </div>
                                ) : null
                              }
                              {
                                item.litigatorDetail.more_information ? (
                                  <div>
                                    {item.litigatorDetail.more_information.inforce
                                      && item.litigatorDetail.more_information.inforce.length !== 0 ? (
                                        <div>
                                          <div className="line" />
                                          <div>
                                            <dl>
                                              <dt>Current Projects</dt>
                                              <dd className="pink">
                                                <em>
                                                  {item.litigatorDetail.more_information.inforce.title}
                                                </em>
                                              </dd>
                                            </dl>
                                            <table className="table_type_2">
                                              <colgroup>
                                                <col style={{ width: '50%' }} />
                                                <col style={{ width: '50%' }} />
                                              </colgroup>
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <table>
                                                      <tbody>
                                                        {item.litigatorDetail.more_information.inforce.list.map(
                                                          (inforce, i) => {
                                                            return (
                                                              i % 2 === 0 && (
                                                                <tr key={uuidv4()}>
                                                                  <td
                                                                    style={{
                                                                      border: '0',
                                                                    }}
                                                                  >
                                                                    {inforce}
                                                                  </td>
                                                                </tr>
                                                              )
                                                            );
                                                          }
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                  <td>
                                                    <table>
                                                      <tbody>
                                                        {item.litigatorDetail.more_information.inforce.list.map(
                                                          (inforce, i) => {
                                                            return (
                                                              i % 2 !== 0 && (
                                                                <tr key={uuidv4()}>
                                                                  <td
                                                                    style={{
                                                                      border: '0',
                                                                    }}
                                                                  >
                                                                    {inforce}
                                                                  </td>
                                                                </tr>
                                                              )
                                                            );
                                                          }
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      ) : null}
                                  </div>
                                ) : null
                              }
                            </Scrollbars>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                );
              })}
              {error && <div className="error_log">{error}</div>}
              {isLoading && (
                <Segment>
                  <Dimmer active inverted>
                    <Loader size="medium" style={{ lineHeight: '15px' }}>Loading</Loader>
                  </Dimmer>
                </Segment>
              )}
              {
                viewMode === 'list' && litigatorList.length !== 0
                && (
                  <div className="clar_pagination" style={{ marginTop: '10px', textAlign: 'center' }}>
                    <Pagination
                      activePage={currentPage}
                      totalPages={totalPage}
                      onPageChange={this.handlePaginationChange}
                      //size="mini"
                      ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                      firstItem={currentPage !== 1 ? { content: <Icon name="angle double left" />, icon: true } : null}
                      lastItem={currentPage !== totalPage ? { content: <Icon name="angle double right" />, icon: true } : null}
                      prevItem={currentPage > 1 ? { content: <Icon name="angle left" />, icon: true } : null}
                      nextItem={currentPage < totalPage ? { content: <Icon name="angle right" />, icon: true } : null}
                    />
                    <div className="active_page">
                      <Input
                        type="number"
                        label={t('list.title.active_page')}
                        min={1}
                        value={activePage}
                        onChange={this.handleInputActivePageChange}
                        onKeyPress={this.handleActivePageChange}
                      />
                    </div>
                  </div>
                )
              }
              {!hasMore && <Footer />}
            </div>
          </div>
        </div>
        <Modal open={this.state.isOpenWarnModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{t('modal.title.attention')}</h2>
                <p className="text">{this.modalBody}</p>
                {
                  this.smallBody
                  && <p className="small_text">{this.smallBody}</p>
                }
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(LitigatorList))));
